import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

/** Ilustraciones vectoriales por familia de nicho. */
const NicheIllustration = ({ type = 'default', width = 120, color = '#ffffff' }) => {
  const h = width * 0.85;
  const c = color;
  const cSoft = `${color}99`;

  const svgs = {
    news: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <rect x="12" y="18" width="72" height="52" rx="8" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M44 38L58 48L44 58V38Z" fill={c} />
        <rect x="20" y="62" width="28" height="4" rx="2" fill={c} opacity="0.7" />
        <rect x="20" y="70" width="40" height="3" rx="1.5" fill={c} opacity="0.45" />
        <circle cx="92" cy="28" r="14" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.2" />
        <path d="M88 28h8M92 24v8" stroke={c} strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    business: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <rect x="28" y="22" width="64" height="58" rx="6" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.12" />
        <path d="M44 72V42h12v30M56 72V52h12v20M68 72V34h12v38" stroke={c} strokeWidth="3" strokeLinecap="round" />
        <path d="M38 72h52" stroke={c} strokeWidth="2" strokeLinecap="round" />
        <circle cx="92" cy="76" r="10" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.25" />
        <path d="M89 76l2 2 4-5" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    marketing: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <circle cx="48" cy="48" r="26" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M74 38l18-10v44l-18-10V38z" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.2" />
        <path d="M40 40c6-4 16-4 22 0M38 52c8 4 20 4 28 0" stroke={c} strokeWidth="2" strokeLinecap="round" opacity="0.85" />
      </svg>
    ),
    education: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <path d="M60 20L16 44l44 24 44-24-44-24z" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.2" />
        <path d="M28 52v22c0 8 14 14 32 14s32-6 32-14V52" stroke={c} strokeWidth="2.5" fill="none" />
        <rect x="88" y="58" width="16" height="28" rx="3" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.15" />
      </svg>
    ),
    wellness: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <circle cx="52" cy="50" r="28" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M52 34v32M36 50h32" stroke={c} strokeWidth="3" strokeLinecap="round" />
        <path d="M78 28c8 6 12 16 10 26" stroke={c} strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <circle cx="88" cy="72" r="8" fill={c} opacity="0.5" />
      </svg>
    ),
    faith: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <path d="M60 18v68M48 32h24" stroke={c} strokeWidth="3" strokeLinecap="round" />
        <ellipse cx="60" cy="78" rx="32" ry="8" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.2" />
        <circle cx="88" cy="36" r="10" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.25" />
        <path d="M84 36h8M88 32v8" stroke={c} strokeWidth="1.5" strokeLinecap="round" opacity="0.8" />
      </svg>
    ),
    stories: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <rect x="24" y="24" width="56" height="44" rx="6" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M32 36h40M32 46h32M32 56h24" stroke={c} strokeWidth="2" strokeLinecap="round" opacity="0.75" />
        <circle cx="88" cy="58" r="14" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.2" />
        <path d="M82 58c2-4 6-6 10-4" stroke={c} strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    justice: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <path d="M60 22v12M40 34h40" stroke={c} strokeWidth="2.5" strokeLinecap="round" />
        <path d="M36 34l-12 36h24L36 34zm48 0l-12 36h24l-12-36z" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.15" />
        <path d="M28 70h64" stroke={c} strokeWidth="3" strokeLinecap="round" />
        <rect x="52" y="70" width="16" height="14" rx="2" fill={c} opacity="0.5" />
      </svg>
    ),
    realestate: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <path d="M60 24L24 48v34h72V48L60 24z" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.2" />
        <rect x="48" y="56" width="24" height="26" rx="2" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.15" />
        <rect x="88" y="40" width="16" height="42" rx="3" stroke={c} strokeWidth="2" fill="none" opacity="0.7" />
      </svg>
    ),
    entertainment: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <rect x="20" y="30" width="64" height="44" rx="8" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M84 42l14 8-14 8V42z" fill={c} />
        <circle cx="36" cy="78" r="4" fill={c} opacity="0.6" />
        <circle cx="52" cy="82" r="3" fill={c} opacity="0.45" />
        <circle cx="68" cy="78" r="4" fill={c} opacity="0.6" />
      </svg>
    ),
    segments: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <rect x="16" y="36" width="24" height="32" rx="4" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.2" />
        <rect x="48" y="28" width="24" height="40" rx="4" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.35" />
        <rect x="80" y="40" width="24" height="28" rx="4" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.2" />
        <path d="M20 24h80" stroke={c} strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4" opacity="0.6" />
      </svg>
    ),
    tourism: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <circle cx="52" cy="48" r="26" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M26 48c0-14 12-26 26-26s26 12 26 26" stroke={c} strokeWidth="2" opacity="0.55" />
        <path d="M68 32l16-8v20l-16-8V32z" fill={c} opacity="0.85" />
        <path d="M44 72h16" stroke={c} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="88" cy="68" r="8" stroke={c} strokeWidth="2" fill={cSoft} fillOpacity="0.25" />
      </svg>
    ),
    default: (
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <circle cx="52" cy="50" r="30" stroke={c} strokeWidth="2.5" fill={cSoft} fillOpacity="0.15" />
        <path d="M44 50h16M52 42v16" stroke={c} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="88" cy="36" r="8" fill={c} opacity="0.5" />
        <circle cx="94" cy="68" r="6" fill={c} opacity="0.35" />
      </svg>
    ),
  };

  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0, flexShrink: 0 }}>
      {svgs[type] || svgs.default}
    </Box>
  );
};

NicheIllustration.propTypes = {
  type: PropTypes.string,
  width: PropTypes.number,
  color: PropTypes.string,
};

export default NicheIllustration;
